import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {NavLink} from "react-router-dom";
import DialogTitle from '@material-ui/core/DialogTitle';
import Badge from '@material-ui/core/Badge';

import 'moment/locale/fr';
import IconButton from "@material-ui/core/IconButton";
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import SyncIcon from '@material-ui/icons/Sync';
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled';
import Tooltip from "@material-ui/core/Tooltip";
moment.locale('fr');

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
});

class ModalSync extends React.Component {

    constructor(props) {
        super(props);

        this.handleSync = this.handleSync.bind(this);
        this.state = {
            open: false,
            status: "sync",
            audits: [],
            submitted: false,
        };
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSync(){
        const _this = this;
        this.setState({ submitted: true }, () => {
            _this.props.syncAudits(_this.state.audits.map(audit=>audit.id))
        });
    }

    componentWillReceiveProps(nextProps){
        const audits = nextProps.audits.filter(audit => audit.status === "appointment");
        if(nextProps.user.google_access_token_expire_at) {
            var list = [];
            for (var i =0; i < audits.length; i++){
                var audit = audits[i];
                var exist = false;
                for (var j =0; j < nextProps.auditsCalendarEvents.length; j++){
                    if(parseInt(nextProps.auditsCalendarEvents[j]['audit_id'], 10 ) === parseInt(audit.id, 10 )){
                        exist = true;
                        break;
                    }
                }
                if(!exist){
                    list.push(audit);
                }
            }
            if (list && list.length > 0) { // Problème de synchronisation
                this.setState({open:false,submitted:false, status: "unsync", audits: list});
            }else{
                this.setState({open:false,submitted:false, status: "sync", audits: []});
            }
        }else{
            this.setState({open:false,submitted:false, status: "disable"});
        }
    }

    render() {
        const status = this.state.status;
        const _this = this;
        const { classes } = this.props;
        return (
            <div>
                {(function() {
                    switch(status) {
                        case 'unsync':
                            return (
                                <Tooltip title="Certains audits ne sont pas synchronisé avec l'agenda">
                                    <IconButton
                                        aria-owns={null}
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={_this.handleClickOpen}
                                    >
                                        <Badge className={classes.margin} badgeContent={_this.state.audits.length} color="secondary">
                                            <SyncProblemIcon />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            );
                        case "disable":
                            return (
                                <NavLink to="/account/" style={{ textDecoration: 'none', color:"#ffffff" }}>
                                    <Tooltip title="Synchronisation de l'agenda désactivé">
                                        <IconButton
                                            aria-owns={null}
                                            aria-haspopup="true"
                                            color="inherit"
                                        >
                                            <SyncDisabledIcon />
                                        </IconButton>
                                    </Tooltip>
                                </NavLink>
                            );
                        default:
                            return (
                                <Tooltip title="Synchronisation de l'agenda activé">
                                    <IconButton
                                        aria-owns={null}
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        <SyncIcon />
                                    </IconButton>
                                </Tooltip>
                            );
                    }
                })()}

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Audits non synchronisé avec votre agenda Google</DialogTitle>
                    <DialogContent>
                        <List component="nav">
                            {this.state.audits.map(audit => (
                                <NavLink key={audit.id} to={"/audits/" + audit.id} style={{ textDecoration: 'none' }}>
                                    <ListItem button >
                                        <ListItemText primary={"Audit ref. " + audit.reference + " | Entreprise : " + audit.company.name} />
                                        <ListItemText primary={moment(audit.date).format("DD/MM/YYYY à HH:mm")} />
                                    </ListItem>
                                </NavLink>
                            ))}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Fermer
                        </Button>
                        <Button
                            onClick={this.handleSync}
                            variant="raised"
                            color="primary"
                            disabled={this.state.submitted}
                            style={{marginRight: 20}}
                        >
                            {
                                (this.state.submitted && "Synchronisation en cours...") ||
                                (!this.state.submitted && "Synchroniser maintenant")
                            }
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

ModalSync.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModalSync);



// WEBPACK FOOTER //
// ./src/component/utils/ModalSync.js